import { enStatus } from 'interface/course';
import { IDownload } from './filedownload';
export interface ILesson {
  fetched: boolean;
  id: number;
  id_module: number;
  module_id: number;
  id_course: number;
  hash_course: string;
  can_reply: boolean;
  allow_multiple_access: number;
  title: string;
  description: string;
  contents: IContent[];
  image: string;
  sequence: number;
  release_date: any;
  days_locked: any;
  slug: string;
  download_enabled: number;
  chats: any;
  description_type: any;
  iframe_url: any;
  iframe_config: any;
  disable_author: boolean;
  disable_comments: boolean;
  disable_ratings: boolean;
  urlFile?: string;
  author: {
    id: any;
    name: string;
    description: any;
    avatar: any;
  };
  watched: number;
  status: enStatus;
  release: string;
  id_vimeo: number;
  lesson_files: IDownload[];
  next: {
    module: number;
    lesson: number;
  };
  previous: {
    module: number;
    lesson: number;
  };
  share: string;
}

export interface IEmbed {
  loginUrl: string;
  testUrl: string;
  error?: string;
  id: string;
}
export interface IRating {
  avg: number;
  user_rating: number;
}
export interface IContent {
  id?: number;
  type: { id: enLessonType; name?: string };
  content?: string;
  embed?: string;
  drm_active?: number;
  download_enabled?: number | boolean;
  topic?: any;
}

export enum enLessonType {
  LOADING = 0,
  YOUTUBE_VIMEO = 1,
  EMBED = 2,
  AOVIVO = 3,
  TEXT = 4,
  AUDIO = 5,
  VIDEOZZ = 6,
  FABRICA_PROVAS = 7,
  TOPIC = 8,
  SAFE_VIDEO = 9,
}

export enum enTypeNextLesson {
  NEXT_LESSON = 0,
  MISSING_WATCH = 1,
}
